<div class="assessment-container">
  <h2>Heart Tones</h2>
  <assessment-row title="Irregular Pulse" [historyMode]="true">
    <p>{{ isIrregularPulse }}</p>
  </assessment-row>
  <assessment-row title="Heart Tones" [historyMode]="true">
    <p>{{ data().heartTones }}</p>
  </assessment-row>
  <assessment-row title="Rhythm" [historyMode]="true">
    <p>{{ data().rhythm }}</p>
  </assessment-row>

  <h2>Edema</h2>
  <assessment-row title="Presence of JVD" [historyMode]="true">
    <p>{{ isJVDPresent }}</p>
  </assessment-row>
  <assessment-row title="Generalized Non-Pitting Edema" [historyMode]="true">
    <p>{{ hasGNPE }}</p>
  </assessment-row>

  <h2>Pitting Edema</h2>
  <assessment-row title="Right Hand" [historyMode]="true">
    <p>{{ data().rightHand }}</p>
  </assessment-row>
  <assessment-row title="Right Foot" [historyMode]="true">
    <p>{{ data().rightFoot }}</p>
  </assessment-row>
  <assessment-row title="Left Foot" [historyMode]="true">
    <p>{{ data().leftFoot }}</p>
  </assessment-row>
  <assessment-row title="Left Hand" [historyMode]="true">
    <p>{{ data().leftHand }}</p>
  </assessment-row>
  <assessment-row title="Generalized Perfusion" [historyMode]="true">
    <p>{{ data().generalizedPerfusion }}</p>
  </assessment-row>
  <assessment-row title="Cap Refill" [historyMode]="true">
    <p>{{ isNormalCapRefill }}</p>
  </assessment-row>

  <h2>Pulses</h2>
  <assessment-row title="RUE" [historyMode]="true">
    <p>{{ data().pulseRue }}</p>
  </assessment-row>
  <assessment-row title="RLE" [historyMode]="true">
    <p>{{ data().pulseRle }}</p>
  </assessment-row>
  <assessment-row title="LUE" [historyMode]="true">
    <p>{{ data().pulseLue }}</p>
  </assessment-row>
  <assessment-row title="LLE" [historyMode]="true">
    <p>{{ data().pulseLle }}</p>
  </assessment-row>

  <assessment-row title="Cyanosis" [historyMode]="true">
    <p>{{ data().cyanosisNoted }}</p>
  </assessment-row>

  <assessment-row title="Pacemaker" [historyMode]="true">
    <p>{{ isPaceMaker }}</p>
  </assessment-row>

  @if (isPaceMaker) {
  <assessment-row title="Pacemaker Comment" [historyMode]="true">
    <p>{{ data().pacemakerComment }}</p>
  </assessment-row>
  }

  <assessment-row title="Other Findings" [historyMode]="true">
    <p>{{ data().otherFindings }}</p>
  </assessment-row>
</div>